
import React from 'react';
import { TableHead, TableHeader, TableRow } from '@/components/ui/table';

const IoTGatewayTableHeader: React.FC = () => {
  return (
    <TableHeader>
      <TableRow>
        <TableHead>Gateway ID</TableHead>
        <TableHead>Location</TableHead>
        <TableHead>Status</TableHead>
        <TableHead>Connected Devices</TableHead>
        <TableHead>Uptime</TableHead>
        <TableHead>CPU/Memory</TableHead>
        <TableHead>Temperature</TableHead>
        <TableHead>Connectivity</TableHead>
        <TableHead>Alerts</TableHead>
      </TableRow>
    </TableHeader>
  );
};

export default IoTGatewayTableHeader;
